export default __webpack_public_path__ + "9ccaf989b76dcbaa9a564de99b6c3840.png";